import { render, staticRenderFns } from "./DisableInboxModal.vue?vue&type=template&id=33eae7c0&"
import script from "./DisableInboxModal.vue?vue&type=script&lang=js&"
export * from "./DisableInboxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports